import { ReactNode } from 'react';
import Term from '../../../components/ui/Term';
import { GLOSSARY, type GlossaryKey } from '../../../lib/glossary';

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  help?: GlossaryKey | string;
  /** Tinted fill (artboard `.box.tint`) for banners and secondary blocks. */
  tint?: boolean;
  className?: string;
  children: ReactNode;
}

/**
 * Artboard `.box`: a 1px line, 16px radius, 18px padding block. The header is `.bh`
 * (title 15px display bold, 14px below, actions centred) so it differs from PanelCard's 17px/18px.
 */
export default function Box({ title, subtitle, actions, help, tint = false, className = '', children }: Props) {
  return (
    <section className={`box-border min-w-0 rounded-[16px] border border-line p-[18px] ${tint ? 'bg-surface-2' : ''} ${className}`}>
      {(title || actions) && (
        <div className="mb-3.5 flex flex-wrap items-center justify-between gap-2.5">
          <div className="min-w-0">
            {typeof title === 'string' ? (
              <h2 className="font-display text-[15px] font-bold tracking-[-0.01em] text-ink">
                {help ? <Term {...(help in GLOSSARY ? { k: help as GlossaryKey } : { def: help })}>{title}</Term> : title}
              </h2>
            ) : title}
            {subtitle && <p className="mt-1 text-[13px] text-muted">{subtitle}</p>}
          </div>
          {actions && <div className="flex max-w-full flex-none flex-wrap items-center gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
